import { Component } from '@angular/core';

@Component({
    selector: 'app-license-header-menu',
    templateUrl: './license-header-menu.component.html',
    styleUrls: ['./license-header-menu.component.scss']
})
export class LicenseHeaderMenuComponent {}
